export default {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '16px',
    color: '#252525',
    '::placeholder': {
        color: '#FFF',
    },
};
